import { useTranslation } from './i18n';
import { dailyCreditsResetTime, type DailyResetLineInputs } from './daily-credits-reset';

export { widgetStateResetInputs } from './daily-credits-reset';

/**
 * "Your daily credits come back at {time}." for a surface, or null → render nothing. The decision and
 * the formatting are the pure `dailyCreditsResetTime`; this only supplies the clock and the app locale.
 */
export function useDailyCreditsResetLine(inputs: DailyResetLineInputs): string | null {
  const { t, i18n } = useTranslation();
  const time = dailyCreditsResetTime(inputs, { now: Date.now(), locale: i18n.language || undefined });
  return time ? t('credits.widget.daily.out.resetsAt', { time }) : null;
}
